// TOUR-20 — RTO terms config (Sales Console calculator inheritance).

import type { FireflyTourArtifact } from "../tourTypes";

export const RTO_TERMS_TOUR_ID = "tour-rto-terms";

export const RTO_TERMS_TOUR: FireflyTourArtifact = {
  id: RTO_TERMS_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "rto terms tour",
    "configure rent to own",
    "rent to own terms tour",
    "how do i configure rto terms",
    "walk me through rto terms",
    "show me rto terms",
    "sales console rto calculator terms",
  ],
  bucketRelevance: ["ops"],
  requiredRoles: ["admin", "owner", "org_admin", "org_owner"],
  steps: [
    {
      id: "nav-rto-terms",
      target: {
        mode: "rtoTerms",
        anchorId: "mode-nav-rtoTerms",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "rtoTerms",
      copy: {
        title: "Open RTO Terms",
        body: "Rent-to-own term rows for the Sales Console calculator live here. Tap RTO Terms in the Ops bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "rto-surface",
      target: { mode: "rtoTerms", anchorId: "rto-terms-surface", scrollIntoView: true },
      copy: {
        title: "RTO Terms hub",
        body: "Set the provider display name Sales Console shows, define term rows (months, divisor, required down), and optional state overrides.",
      },
      advanceOn: "next_button",
    },
    {
      id: "mfg-inherit",
      target: { mode: "rtoTerms", anchorId: "rto-mfg-inherit", scrollIntoView: true },
      copy: {
        title: "Manufacturer inheritance",
        body: "When a manufacturer is linked, Use manufacturer RTO terms pulls their calculator rows instead of org-authored terms. Turn it off to edit org terms below.",
      },
      advanceOn: "next_button",
    },
    {
      id: "terms-table",
      target: { mode: "rtoTerms", anchorId: "rto-terms-table", scrollIntoView: true },
      copy: {
        title: "Term definitions",
        body: "Each row is a term Sales Console can pick — name, months, divisor, and down payment rules. Add states once, then override early-purchase % per state on a term.",
      },
      advanceOn: "next_button",
    },
    {
      id: "terms-save",
      target: { mode: "rtoTerms", anchorId: "rto-terms-save", scrollIntoView: true },
      copy: {
        title: "Save RTO terms",
        body: "Save RTO terms persists inheritance and org term rows for this workspace. You perform the save yourself — the tour will not write changes. Sales Console reads these on the next calculator open.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "rtoTerms", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Reps use these terms from Sales Console → RTO calculator — not this editor. Ask Firefly anytime for the Sales Console tour or deal paperwork.",
      },
      advanceOn: "next_button",
    },
  ],
};
